import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-contrast-2-fill text-white text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white whitespace-nowrap">
                {t('siteName')}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400 max-w-md">
              {t('footerDescription')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">{t('navHome')}</Link>
              <Link to="/category/contrast-visual-design" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">设计</Link>
              <Link to="/category/contrast-photography" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">摄影</Link>
              <Link to="/category/contrast-copywriting" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">文案</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">{t('navAbout')}</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">关注我们</h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="Bilibili">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">{t('copyright')}</p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}